import { get, isEmpty } from 'lodash'
import { required, requiredCheck, email } from 'utils/validation'
import { CONFIGURATION_KEYS } from 'constants/enums'

const validate = (values, props = {}) => {
  let errors = {}

  const hasConductEnabled = get(props, `configuration.values[${CONFIGURATION_KEYS.auCoConduct.id}].booleanValue`, false)
  const conductUrl = get(props, `configuration.values[${CONFIGURATION_KEYS.auCoConductDoc.id}].fileUrl`)

  const isNaoRegRequirementEnabled = get(props, `configuration.values[${CONFIGURATION_KEYS.enableNaoRegRequirements.id}].booleanValue`, false)
  const naoRegRequirementUrl = get(props, `configuration.values[${CONFIGURATION_KEYS.naoRegRequirementsUrl.id}].textValue`)

  const isPrivacyPolicyAgreementEnabled = get(props, `configuration.values[${CONFIGURATION_KEYS.enablePrivacyPolicyAgreement.id}].booleanValue`, false)
  const privacyPolicyUrl = get(props, `configuration.values[${CONFIGURATION_KEYS.privacyPolicyUrl.id}].textValue`)

  const helpers = {
    naa: (!get(values, 'isIacRegistration') && isNaoRegRequirementEnabled && naoRegRequirementUrl) && requiredCheck(get(values, 'helpers.naa')),
    agreementPrivacyPolicy: (isPrivacyPolicyAgreementEnabled && privacyPolicyUrl) && requiredCheck(get(values, 'helpers.agreementPrivacyPolicy')),
    agreementCodeOfConduct: (hasConductEnabled && conductUrl) && requiredCheck(get(values, 'helpers.agreementCodeOfConduct')),
    terms: requiredCheck(get(values, 'helpers.terms'))
  }

  errors = {
    helpers: !isEmpty(helpers) && helpers
  }

  errors.awardLeaderRegistration = {
    email: required(get(values, 'awardLeaderRegistration.email')) ||
      email(get(values, 'awardLeaderRegistration.email')),
    passwordAgain: required(
      get(values, 'awardLeaderRegistration.passwordAgain')
    )
  }

  if (hasConductEnabled && conductUrl) {
    errors = {
      ...errors,
      agreementCodeOfConduct: requiredCheck(get(values, 'agreementCodeOfConduct'))
    }
  }

  if (
    get(values, 'awardLeaderRegistration.password') &&
    get(values, 'awardLeaderRegistration.passwordAgain')
  ) {
    if (
      get(values, 'awardLeaderRegistration.password') !==
      get(values, 'awardLeaderRegistration.passwordAgain')
    ) {
      errors.awardLeaderRegistration = {
        ...errors.awardLeaderRegistration,
        passwordAgain: {
          text: "Passwords don't match",
          intlKey: 'errors.passwords_dont_match',
          values: {}
        }
      }
    }
  }

  return errors
}

export default validate
